import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { useAuthState } from "react-firebase-hooks/auth";
import Skeleton from "react-loading-skeleton";
import NoData from "../../../components/Ui/NoData";
import auth from "../../../init.firebase";
import AllOrder from "./AllOrder";
import "react-loading-skeleton/dist/skeleton.css";
import { useGetAllOrdersByEmailQuery } from "../../../redux/addToCart/addToCartApi";

const ViewOrders = () => {
  const [user] = useAuthState(auth);
  const [haveUser, setHaveUser] = useState(true);
  const userEmail = user?.email;

  const {
    data: orders,
    isLoading,
    isError,
  } = useGetAllOrdersByEmailQuery(userEmail, { skip: haveUser });
  useEffect(() => {
    if (user?.email) {
      setHaveUser(false);
    }
  }, [user?.email]);
  let content = null;
  if (isLoading) {
    content = <Skeleton count={3} />;
  }
  if (!isLoading && isError) {
    content = <p className="text-center text-danger">There was en error</p>;
  }
  if (!isLoading && !isError && !orders?.products?.length) {
    content = <NoData />;
  }
  if (!isLoading && !isError && orders?.length > 0) {
    const reverseOrders = [...orders]?.reverse();

    content = reverseOrders?.map((order) => <AllOrder order={order} />);
  }
  console.log(orders);
  return (
    <>
      <div>
        <h2 className="text-start">View Orders</h2>
        <div className="doted-container"></div>
      </div>
      {content}
    </>
  );
};

export default ViewOrders;
